import React from 'react';
import ReactDOM from 'react-dom/client';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './i18n/en.json';
import zhCNTranslations from './i18n/zh-CN.json';
import zhTWTranslations from './i18n/zh-TW.json';
import thTranslations from './i18n/th.json';
import deTranslations from './i18n/de.json';
import frTranslations from './i18n/fr.json';
import App from './App';
import { TenantConfigProvider } from './contexts/TenantConfigContext';
import './global.css';

// ui_language = explicit UI preference (set by LanguageSelector / language tag)
// user_language = account setting stored at login — only used as fallback
const detectedLang =
  localStorage.getItem('ui_language') ??
  sessionStorage.getItem('user_language') ??
  'en';

// Use .then() instead of top-level await so the build target stays compatible
// with browsers that support ES modules but not top-level await (Chrome <89,
// Safari <15). i18n.init() is synchronous with bundled resources — this
// resolves before the browser paints.
i18next
  .use(initReactI18next)
  .init({
    lng: detectedLang,
    fallbackLng: 'en',
    defaultNS: 'training',
    resources: {
      en:      { training: enTranslations   },
      'zh-CN': { training: zhCNTranslations },
      'zh-TW': { training: zhTWTranslations },
      th:      { training: thTranslations   },
      de:      { training: deTranslations   },
      fr:      { training: frTranslations   },
    },
    interpolation: {
      // React already escapes values — no double-escaping needed
      escapeValue: false,
    },
  })
  .then(() => {
    // ---------------------------------------------------------------------------
    // React mount — only after i18n is ready to avoid flash of untranslated UI
    // ---------------------------------------------------------------------------
    const rootEl = document.getElementById('root');
    if (!rootEl) {
      throw new Error('[ARIA Training] Root element #root not found in index.html');
    }

    ReactDOM.createRoot(rootEl).render(
      <React.StrictMode>
        <TenantConfigProvider>
          <App />
        </TenantConfigProvider>
      </React.StrictMode>,
    );
  });
